import { Button, Col, List, Row } from 'antd';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import trapImageApi from '../../../apis/TrapImageApi';
import { TrapImage, TrapPlot } from '../../../models/Entities';
import alertService from '../../../services/AlertService';
import styles from './TrapImagesViewerComponent.module.scss';
import TrapImagesViewerImageComponent from './TrapImagesViewerImageComponent/TrapImagesViewerImageComponent';

/**
 * Returns the trap images viewer component.
 * @returns the traps images viewer component.
 */
const TrapImagesViewerComponent: React.FC<Props> = (props) => {
    const { trapPlot } = props;

    /*** HOOKS ***/

    const pageSize = 12;
    const intl = useIntl();
    const [trapImages, setTrapImages] = useState<TrapImage[]>([]);
    const [page, setPage] = useState<number>(0);
    const [lastPage, setLastPage] = useState<boolean>(true);
    const [loading, setLoading] = useState<'loading'>();

    /*** EFFECTS ***/

    useEffect(() => {
        const init = async () => {
            try {
                setLoading('loading');
                const trapImagesPage = await trapImageApi.list(0, pageSize, 'date', false, undefined, trapPlot.id);
                setPage(trapImagesPage.number);
                setLastPage(trapImagesPage.last);
                setTrapImages(trapImagesPage.content);
            } catch (error) {
                alertService.displayError(error, intl);
            } finally {
                setLoading(undefined);
            }
        };
        init();
    }, [intl, trapPlot]);

    /*** METHODS ***/

    const loadMore = async () => {
        try {
            setLoading('loading');
            const trapImagesPage = await trapImageApi.list(page + 1, pageSize, 'date', false, undefined, trapPlot.id);
            const updatedTrapImages = [...trapImages, ...trapImagesPage.content];
            setPage(trapImagesPage.number);
            setLastPage(trapImagesPage.last);
            setTrapImages(updatedTrapImages);
        } catch (error) {
            alertService.displayError(error, intl);
        } finally {
            setLoading(undefined);
        }
    };

    /*** VISUAL ***/
    return (
        <Row>
            <Col lg={24}>
                <List
                    itemLayout="vertical"
                    size="large"
                    dataSource={trapImages}
                    loading={loading === 'loading'}
                    loadMore={
                        trapImages && !lastPage ? (
                            <div className={styles.buttons}>
                                <Button type="primary" size="large" onClick={loadMore}>
                                    <FormattedMessage id="button.loadMore" />
                                </Button>
                            </div>
                        ) : (
                            <></>
                        )
                    }
                    grid={{
                        gutter: 0,
                        xs: 1,
                        sm: 1,
                        md: 2,
                        lg: 3,
                        xl: 3,
                        xxl: 4
                    }}
                    renderItem={(trapImage) => (
                        <List.Item key={trapImage.id}>
                            <TrapImagesViewerImageComponent trapImage={trapImage} />
                        </List.Item>
                    )}
                />
            </Col>
        </Row>
    );
};
export default TrapImagesViewerComponent;

interface Props {
    trapPlot: TrapPlot;
}
